import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/index.css';
import { showError, showSuccess } from '../utils/alertas';

// --- 🛠️ CONFIGURAÇÃO DE CONEXÃO ---
const IS_PROD = true; 

const API_BASE_URL = IS_PROD 
    ? 'https://sigoapi.jhe-etes.com.br/api' 
    : 'http://localhost:3001/api';

function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    console.log(`📡 Tentando conectar em: ${API_BASE_URL}/login`);

    try {
      const response = await fetch(`${API_BASE_URL}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, senha }) 
      });

      const data = await response.json();

      if (response.ok) {
        // ✅ SUCESSO: SALVANDO COM O NOME CERTO AGORA!
        // Antes estava 'sigo_token', agora é apenas 'token' para bater com os modais
        localStorage.setItem('token', data.token); 
        localStorage.setItem('user', JSON.stringify(data.user));
        
        await showSuccess("Acesso Permitido", `Bem-vindo de volta, ${data.user.nome}!`);
        navigate('/'); // Redireciona para o Mapa
      } else {
        // ❌ ERRO DE CREDENCIAIS
        showError("Falha no Login", data.message || "Verifique suas credenciais.");
      }
    } catch (error) {
      // ⚠️ ERRO DE CONEXÃO
      console.error("Erro no fetch:", error);
      showError(
        "Erro de Conexão", 
        "Não foi possível falar com o servidor. Verifique se o backend está rodando."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex h-screen items-center justify-center bg-slate-100 font-sans">
      <div className="bg-white p-10 rounded-3xl shadow-2xl w-full max-w-md border border-gray-100 relative overflow-hidden">
        
        {/* Faixa decorativa no topo */}
        <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-sabesp-blue to-sabesp-cyan"></div>

        <div className="text-center mb-8">
          <span className="text-5xl block mb-2 drop-shadow-sm">💧</span>
          <h1 className="text-3xl font-black text-sabesp-blue tracking-tight">SIGO Sabesp</h1>
          <p className="text-gray-400 font-bold uppercase tracking-widest text-[10px] mt-2">Sistema Integrado de Gestão</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-5">
          <div>
            <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-2 ml-1">Usuário</label>
            <input 
              type="text" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full p-4 bg-gray-50 border border-gray-200 rounded-xl text-gray-700 font-bold focus:border-sabesp-cyan focus:ring-4 focus:ring-sabesp-cyan/10 outline-none transition-all placeholder:text-gray-300"
              placeholder="Digite seu usuário..."
            />
          </div>

          <div>
            <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-2 ml-1">Senha</label>
            <input 
              type="password" 
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              className="w-full p-4 bg-gray-50 border border-gray-200 rounded-xl text-gray-700 font-bold focus:border-sabesp-cyan focus:ring-4 focus:ring-sabesp-cyan/10 outline-none transition-all placeholder:text-gray-300"
              placeholder="••••••"
            />
          </div>

          <button 
            type="submit" 
            disabled={loading}
            className="w-full py-4 bg-sabesp-blue text-white font-bold rounded-xl hover:bg-blue-900 transition-all shadow-lg hover:shadow-xl flex justify-center items-center active:scale-95 disabled:opacity-70 disabled:cursor-not-allowed mt-4"
          >
            {loading ? (
                <div className="flex items-center gap-2">
                    <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></span>
                    <span>Conectando...</span>
                </div>
            ) : 'Entrar no Sistema'}
          </button>
        </form>

        {/* Botão para voltar ao Mapa sem logar */}
        <div className="mt-8 text-center border-t border-gray-100 pt-6">
            <button 
                onClick={() => navigate('/')}
                className="text-gray-400 text-xs font-bold hover:text-sabesp-blue transition-colors flex items-center justify-center gap-2 mx-auto group uppercase tracking-wider"
            >
                <span className="group-hover:-translate-x-1 transition-transform text-lg">←</span> Voltar ao Mapa Público
            </button>
        </div>

      </div>
    </div>
  );
}

export default Login;